import styled from 'styled-components'
import { grid } from '../../styles/vars/grid.style'
import { clamp, getClampValue } from '../../styles/utils/conversion.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'
import { mq } from '../../styles/vars/media-queries.style'
import { easings } from '../../styles/vars/easings.style'
import { Label, Title } from '../../styles/vars/textStyles.style'
import { colors } from '../../styles/vars/colors.style'

export const CarouselItemImageHover = styled.div`
  height: 100%;
  width: 100%;

  > span {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;

    img {
      height: 100%;
      width: 100%;
    }
  }

  &:after {
    transition: opacity 1.5s ${easings.out.quart};
  }

  &:after {
    background-color: ${colors.dark};
    bottom: 0;
    content: '';
    opacity: 0;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
  }

  > svg {
    left: 50%;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 3;
  }
`

export const CarouselItemMain = styled.div`
  height: 100%;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  will-change: transform;
  ${({ featured }) => featured === true && `cursor: pointer;`}

  &:first-child {
    position: relative;
  }

  transform: translateX(
    calc(
      ${props =>
          props.index > 0 && props.featured
            ? `${props.index} * 60%`
            : `${props.index} * 100%`} +
        ${props => props.index * grid.gap.min}px
    )
  );
  transform: translateX(
    calc(
      ${props =>
          props.index > 0 && props.featured
            ? `${props.index} * 60%`
            : `${props.index} * 100%`} +
        ${props =>
          getClampValue(
            props.index * grid.gap.min,
            props.index * grid.gap.max,
            breakpoints.mobile,
            breakpoints.contained
          )}
    )
  );
  transition: ${props =>
    props.transitions
      ? props.featured && props.index === 0
        ? `transform 1s ${easings.inOut.quart}, width 1s ${easings.inOut.quart}`
        : props.featured && props.index === 1
        ? `transform 1s ${easings.inOut.quart}, width 1s ${easings.inOut.quart}`
        : `transform 1s ${easings.inOut.quart}`
      : ``};

  ${mq.desk} {
    transform: translateX(
      calc(
        ${props =>
            props.index > 0 && props.featured
              ? `${props.index} * 40%`
              : `${props.index} * 100%`} +
          ${props =>
            getClampValue(
              props.index * grid.gap.min,
              props.index * grid.gap.max,
              breakpoints.mobile,
              breakpoints.contained
            )}
      )
    );

    ${props =>
      props.featured &&
      `
      &:hover {
        ${CarouselItemImageHover} {
          &:after {
            transition: opacity 2s ${easings.out.quart};
          }
          &:after {
            opacity: .2;
          }
        }
      }
    `}
  }
`

export const CarouselItemImage = styled.div`
  ${props =>
    clamp(
      'height',
      props.featured ? 221 : 412,
      props.featured ? 741 : 575,
      breakpoints.mobile,
      breakpoints.contained,
      true
    )};
  margin-left: auto;
  margin-right: 0;
  position: relative;
  transition: ${props =>
    props.transitions
      ? props.featured && props.index === 0
        ? `transform 1s ${easings.inOut.quart}, width 1s ${easings.inOut.quart}`
        : props.featured && props.index === 1
        ? `transform 1s ${easings.inOut.quart}, width 1s ${easings.inOut.quart}`
        : `transform 1s ${easings.inOut.quart}`
      : ``};
  width: ${props => (props.featured && props.index > 0 ? `60%` : `100%`)};

  ${mq.desk} {
    width: ${props => (props.featured && props.index > 0 ? `40%` : `100%`)};
  }
`

export const CarouselItemImageInner = styled.div`
  border-radius: 0.6rem;
  bottom: 0;
  height: ${props => (props.featured && props.index > 0 ? `75%` : `100%`)};
  left: 0;
  overflow: hidden;
  pointer-events: ${props => (props.transitions ? `none` : `all`)};
  position: absolute;
  right: 0;
  transition: ${props =>
    props.transitions ? `height 1s ${easings.inOut.quart}` : ``};
`

export const CarouselItemText = styled.div`
  margin-left: auto;
  margin-right: 0;
  pointer-events: all;
  transition: ${props =>
    props.transitions
      ? props.featured && props.index === 0
        ? `transform 1s ${easings.inOut.quart}, width 1s ${easings.inOut.quart}`
        : props.featured && props.index === 1
        ? `transform 1s ${easings.inOut.quart}, width 1s ${easings.inOut.quart}`
        : `transform 1s ${easings.inOut.quart}`
      : ``};
  width: ${props => (props.featured && props.index > 0 ? `60%` : `100%`)};

  ${mq.desk} {
    width: ${props => (props.featured && props.index > 0 ? `40%` : `100%`)};
  }
`

export const CarouselItemTitle = styled.div`
  ${Title} {
    white-space: nowrap;
  }
`

export const CarouselItemLabel = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;

  ${Label} {
    white-space: nowrap;
  }
`

export const CarouselItemPin = styled.div`
  display: flex;

  svg {
    display: inline-block;
    margin-bottom: 0.1rem;
    margin-right: 1.1rem;
    min-width: 2.6rem;
  }
`
